import AbstractFilter from './AbstractFilter';

export default class ToArray extends AbstractFilter
{
    filter(value: any): any[]
    {
        return Array.isArray(value) ? value : [value];
    }
}